var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChangeModal',{ref:"modal",attrs:{"help":"HelpMission"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Mission Statement")])])
}
var staticRenderFns = []

export { render, staticRenderFns }